import { HistoricalTable } from '../components/HistoricalTable';

/**
 * Ads History page — paginated list of terminal ads jobs with filters
 * for status / date / scan id and per-row View / Rerun / Delete
 * actions. Clicking a completed row opens
 * :class:`web/src/ads/components/AdsImagesModal` so the operator can
 * preview and download every generated format.
 */
export function AdsHistoryPage() {
  return (
    <div className="space-y-6">
      <HistoricalTable />
    </div>
  );
}
